import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { LinkTarget } from '@panaya/ui/p-link';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    selector: 'p-field-href',
    template: `
        <p-field
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="true"
            [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
        >
            <p-link slot="readMode" class="p-field-href-text" [url]="value?.url" [target]="target" (onClick)="hrefClick.emit($event)">
                {{ value?.text }}
            </p-link>
        </p-field>
    `,
    styleUrls: ['./p-field-href.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFieldHrefComponent extends PFieldAbstractComponent<HrefData> {
    @Input() label?: string;
    @Output() hrefClick = new EventEmitter<any>();
    @Input() target?: LinkTarget;

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }
}

interface HrefData {
    text: string;
    url: string;
}
